import script from "./SearchBarCorp.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchBarCorp.vue?vue&type=script&setup=true&lang=js"

import "./SearchBarCorp.vue?vue&type=style&index=0&id=9feedba2&lang=css"

const __exports__ = script;

export default __exports__